var map = {
	"./template.bet777": 1610,
	"./template.bet777.tsx": 1610,
	"./template.buffalobet": 1611,
	"./template.buffalobet.tsx": 1611,
	"./template.chromabet": 1612,
	"./template.chromabet.tsx": 1612,
	"./template.default": 668,
	"./template.default.tsx": 668,
	"./template.gigabet": 1613,
	"./template.gigabet.tsx": 1613,
	"./template.goldenbet888": 1614,
	"./template.goldenbet888.tsx": 1614,
	"./template.slambet": 1615,
	"./template.slambet.tsx": 1615,
	"./template.templebet": 1616,
	"./template.templebet.tsx": 1616,
	"./template.titanbet": 1617,
	"./template.titanbet.tsx": 1617,
	"./template.ts": 982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2452;